export var MultifactorAuthenticationIA = function MultifactorAuthenticationIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return MULTIFACTOR_AUTHENTICATION_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [MULTIFACTOR_AUTHENTICATION_DESCRIPTION(strictLocalize), MULTIFACTOR_AUTHENTICATION_CONTACT_US(strictLocalize)];
    }
  };
};
var MULTIFACTOR_AUTHENTICATION_TITLE = function MULTIFACTOR_AUTHENTICATION_TITLE(strictLocalize) {
  return strictLocalize({
    id: "A77NhJ",
    defaultMessage: [{
      "type": 0,
      "value": "Autenticação multifator"
    }]
  });
};
var MULTIFACTOR_AUTHENTICATION_DESCRIPTION = function MULTIFACTOR_AUTHENTICATION_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "q2lRAt",
    defaultMessage: [{
      "type": 0,
      "value": "Na Faire, implementámos medidas de segurança para proteger a sua conta contra o acesso não autorizado. Como parte destas medidas, podemos solicitar informações adicionais, como um código de autenticação multifator (MFA), para garantir que é a única pessoa com acesso à sua conta. Isto é feito para proteger a segurança e a privacidade da conta e evitar possíveis atividades não autorizadas."
    }]
  });
};
var MULTIFACTOR_AUTHENTICATION_CONTACT_US = function MULTIFACTOR_AUTHENTICATION_CONTACT_US(strictLocalize) {
  return strictLocalize({
    id: "L5tq/m",
    defaultMessage: [{
      "type": 0,
      "value": "Em caso de dúvidas ou questões sobre a autenticação multifator, contacte-nos."
    }]
  });
};